import { useState } from 'react';
import type { BusinessGroupBy } from '../../types/businessMetrics';
import { BusinessMetricsView } from './BusinessMetricsView';
import { useBusinessMetrics } from './useBusinessMetrics';

/** 앱별 Metrics 화면의 사업 지표 섹션. 기간은 MetricsPage 의 시작·종료일을 그대로 쓴다. */
export function BusinessMetricsSection({
  applicationId,
  startDate,
  endDate,
}: {
  applicationId: string;
  startDate: string;
  endDate: string;
}) {
  const [groupBy, setGroupBy] = useState<BusinessGroupBy>('DAY');
  const { data, loading, error, reload } = useBusinessMetrics(applicationId, startDate, endDate, groupBy);
  return (
    <BusinessMetricsView
      data={data}
      loading={loading}
      error={error}
      groupBy={groupBy}
      onGroupByChange={setGroupBy}
      onReload={reload}
    />
  );
}
